import { useDataChange, useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'global',
  })
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'global',
  })
  let global = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
  })
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_actions',
    path: 'patient.id',
  })
  let appointment_id = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_actions',
    path: 'appointment.id',
  })
  let appointment_booking_location = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_actions',
    path: 'appointment_booking.location',
  })
  let is_patient_overlay_call = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_actions',
    path: 'is_patient_overlay_call',
  })

  return async function onClick() {
    let sync = {
      patient_id,
      appointment_id,
      is_patient_overlay_call,
      location: appointment_booking_location,
    }

    if (global.tab_id !== 'Calendar') {
      await submit({
        type: global.tabs.includes('Calendar') ? 'tabs/select' : 'tabs/add',
        tab: {
          id: 'Calendar',
          name: 'Calendar',
          type: 'Calendar',
          viewPath: '/App/Account/Content/Calendar',
          sync,
        },
      })
    } else {
      change(next => {
        next.tabs = next.tabs.map(tab =>
          tab.id === 'Calendar'
            ? {
                ...tab,
                sync,
              }
            : tab
        )
      })
    }
  }
}
